<script setup lang="ts">
import { GroupingError } from '@/store/modules/stay/types'

defineProps<{
  error: GroupingError | null
  isCritical: boolean | null
}>()

</script>

<template>
  <div
    v-if="error"
    :class="isCritical ? 'ghm-error' : 'ghm-warning'"
    class="text-center"
  >
    <span>[{{ error.code }}] {{ error.description }}</span>
  </div>
</template>

<style lang="scss" scoped>
@import '@sancare/typescript-commons/src/assets/styles/variables';

.ghm-error {
  color: $sancare-red;
}

.ghm-warning {
  color: $sancare-orange;
}
</style>
